module.exports = __webpack_public_path__ + "static/media/yt-wall-star.056b23f3.mov";